import React, { useState, useMemo } from 'react';
import faqData from '../../data/faq-data.json'; 
import Accordion from '../../components/common/Accordion';
import MultiSelectCombobox from '../../components/common/MultiSelectCombobox'; // 新しいコンポーネントをインポート

const FaqPage = () => {
  const { faqs, categories } = faqData;
  
  const [selectedCategories, setSelectedCategories] = useState([]); 
  const [searchTerm, setSearchTerm] = useState('');

  const filteredFaqs = useMemo(() => {
    let filtered = faqs;

    // 1. キーワードでフィルタリング
    if (searchTerm.trim() !== '') {
      const lowercasedTerm = searchTerm.toLowerCase();
      filtered = filtered.filter(faq => 
        (faq.question && faq.question.toLowerCase().includes(lowercasedTerm)) ||
        (faq.answer && faq.answer.toLowerCase().includes(lowercasedTerm))
      );
    }

    // 2. カテゴリでフィルタリング (OR条件に変更)
    if (selectedCategories.length > 0) {
      const selectedCategoryNames = selectedCategories.map(c => c.name);
      filtered = filtered.filter(faq => 
        // 選択されたカテゴリのいずれか(some)に一致すれば表示する
        Array.isArray(faq.categories) && selectedCategoryNames.some(catName => faq.categories.includes(catName))
      );
    }

    return filtered;
  }, [faqs, selectedCategories, searchTerm]);

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-white p-6 sm:p-8 w-full max-w-4xl mx-auto my-8 shadow-lg rounded-lg">
        <h1 className="text-3xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-gray-200">
          よくある質問
        </h1>

        {/* Search and Filter Controls */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          {/* Keyword Search Input */}
          <div>
            <label htmlFor="search-faq" className="block text-sm font-medium text-gray-700 mb-1">キーワード検索</label>
            <input 
              id="search-faq"
              type="text"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              placeholder="キーワードを入力..."
              className="w-full px-4 py-2 text-base border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition duration-300"
            />
          </div>

          {/* Category Multi-Select Combobox */}
          <div>
            <label htmlFor="category-select" className="block text-sm font-medium text-gray-700 mb-1">カテゴリー選択</label>
            <MultiSelectCombobox 
              options={categories} 
              selectedOptions={selectedCategories}
              onChange={setSelectedCategories}
              placeholder="カテゴリーを選択..."
            />
          </div>
        </div>


        {/* FAQ Accordion */}
        <div className="space-y-4">
          {filteredFaqs.length > 0 ? (
            filteredFaqs.map(faq => (
              <Accordion key={faq.id} title={faq.question}>
                <div className="prose max-w-none p-4" dangerouslySetInnerHTML={{ __html: faq.answer.replace(/\n/g, '<br />') }} />
                {faq.imageUrl && 
                  <img src={faq.imageUrl} alt="" className="mt-2 rounded-lg max-w-sm h-auto mx-auto"/>
                }
              </Accordion>
            ))
          ) : (
            <div className="text-center text-gray-500 bg-gray-50 p-8 rounded-lg">
              <p className="text-lg">該当する質問が見つかりませんでした。</p>
              <p className="text-sm mt-2">検索キーワードやカテゴリを変更して、もう一度お試しください。</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FaqPage;
